import React, { FunctionComponent } from 'react';
import { Image } from 'react-bootstrap';
import styles from './styles.module.scss';
import { IBindingAction } from '../../common/models/callback';

interface IImageWrapperProps {
  text?: string;
  textStyles?: React.CSSProperties;
  src?: string;
  height: string;
  width: string;
  onClick?: IBindingAction;
}

const ImageWrapper: FunctionComponent<IImageWrapperProps> = ({ src, width, height, text, textStyles, onClick }) => (
  !src
    ? (
      <div
        className={styles.placeholder}
        role="presentation"
        onClick={onClick}
        style={{ width, height }}
      >
        <span style={textStyles}>{text}</span>
      </div>
    )
    : (
      <div>
        <Image
          src={src}
          width={width}
          style={{ minWidth: width, minHeight: height }}
          onClick={onClick}
          height={height}
        />
      </div>
    )
);

export default ImageWrapper;
